// @flow
import React from 'react';
import type { AnyIcon } from '~/core/constants/icons';
import getIconComponent from './map';
import svgComponents from './svg-components';
import { IconStyle } from './style';

const { Svg } = svgComponents;

type Props = {
    color?: string,
    className?: string,
    style?: Object,
    type: AnyIcon
};

const SVGIcon = ({ color, className, type, style }: Props) => (
    <Svg className={className} height="100%" style={style} viewBox="0 0 40 40" width="100%">
        <IconStyle color={color}>{getIconComponent(type, { svgComponents })}</IconStyle>
    </Svg>
);

export default SVGIcon;



// WEBPACK FOOTER //
// ./src/core/icons/svg-icons/index.js